import { Component, Input, OnInit } from '@angular/core';
import { OrdersSearch } from 'src/app/models/orders';
import { emptyFields } from 'src/app/utilities/common-file';
import { CommonService } from 'src/app/utilities/common-service';
import { NzDrawerRef } from 'src/app/utilities/ng-zorro-antd.module';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { OrdersService } from '../../orders.service';

@Component({
  selector: 'app-receipt-order-details',
  templateUrl: './receipt-order-details.component.html',
 })
export class ReceiptOrderDetailsComponent implements OnInit {
  @Input() selectedOrders:any;
  loading=false;
  data:any;
  emptyField = emptyFields;
  private tableData: NzTableData<OrdersSearch, any> = new NzTableData<OrdersSearch, any>(new OrdersSearch(), 'fullName');
  constructor(private ordersService: OrdersService,
              private commonService:CommonService,
              private drawerRef: NzDrawerRef, 
              ) { }

  ngOnInit() {
    this.data = this.selectedOrders;
    this.refresh();
  }
// For List
refresh(startFromPageOne: boolean = true): void {
  this.loading = true;
  this.tableData.data = [];
  if (startFromPageOne) {
    this.tableData.pageIndex = 1;
  }
  console.log(this.tableData);
  this.tableData.search.id=this.selectedOrders.id;
  this.ordersService.orderReceiptListWithLimit(this.tableData).subscribe((response: any) => {
     this.loading = false;
    this.tableData.total = response.data.total;
    if (response.data && response.data.merchantOrderReceipts) {
      this.tableData.data = response.data.merchantOrderReceipts;
    } else {
      this.tableData.data = [];
    }
  }, (err) => {
    this.loading = false;
    this.tableData.data = [];
  });
}
getStatus(status) {
  return this.commonService.getOrderStatus(status);
}
// For Status 
getPaymentStatus(status) {
  return this.commonService.getPaymentStatus(status);
}
getPaymentColor(value) {
  return this.commonService.getColorForPaymentStatus(value);
}
close() {
  this.drawerRef.close();
}
getDeliveryMethod(row){
  return this.commonService.getDeliveryMethod(row);
}
getDeliveryAddress(row){
  let data = JSON.parse(row)
  return data.replace(/[{}]/g, '');
}
}
